module.exports = __webpack_public_path__ + "img/parcel-not-picked-up-at-vendor.560ea18c.svg";